var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8242 13.6075L13.3752 16.0942V4.90424C13.3752 4.41444 12.9608 4 12.471 4H11.5667C11.0392 4 10.6625 4.41444 10.6625 4.90424V16.0942L8.17582 13.6075C7.83673 13.2684 7.23391 13.2684 6.89482 13.6075L6.25432 14.248C5.91523 14.5871 5.91523 15.19 6.25432 15.529L11.3783 20.6154C11.7174 20.9921 12.2826 20.9921 12.6217 20.6154L17.7457 15.529C18.0848 15.19 18.0848 14.5871 17.7457 14.248L17.1052 13.6075C16.7661 13.2684 16.1633 13.2684 15.8242 13.6075Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.25da0dd84ffe0b305fcf4a58ed20d065.svg";
export { ForwardRef as ReactComponent };